require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-statement-on-the-inspection-panels-recommendation.json") })
        }
      }, "path---en-us-update-statement-on-the-inspection-panels-recommendation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-statement-on-the-inspection-panels-recommendation!./.cache/json/en-us-update-statement-on-the-inspection-panels-recommendation.json
// module id = 794
// module chunks = 231608221292675